import { useTranslation } from 'react-i18next';

import type { ReactNode } from 'react';

import computer_connection_unavailable from 'Assets/images/computer_connection_unavailable.svg';
import { Link } from 'Components';
import { StyledFullInlineMessage } from 'Components/Styled';
import { urls } from 'Router';

import { ContentWrapper, InfoText, MissingPreviewLinkIcon } from './machine-info.styles';

type Props = {
  courseId: string;
  isTrainer: boolean;
  isTrainerDesktopPreview: boolean;
  isCourseCompleted: boolean;
};

export const MachineInfo = ({
  courseId,
  isTrainer = false,
  isTrainerDesktopPreview = false,
  isCourseCompleted
}: Readonly<Props>) => {
  const { t } = useTranslation();

  let textToRender: ReactNode;

  if (isTrainerDesktopPreview) {
    textToRender = <div>{t('coursesPage.trainerMachineIsNotStarted')}</div>;
  } else if (isCourseCompleted) {
    textToRender = <div>{t('coursesPage.computerNotAvailable')}</div>;
  } else if (isTrainer) {
    textToRender = (
      <>
        <div>{t('coursesPage.computerNotAvailable')}</div>

        <StyledFullInlineMessage>
          {t('coursesPage.prepareVirtualComputerTemplateInTrainingSettings')}{' '}
          <Link
            to={urls.courseSettingsPage(courseId)}
            label={t('coursesPage.trainingSettings')}
            shouldOpenInNewTab={false}
          />
        </StyledFullInlineMessage>
      </>
    );
  } else {
    textToRender = (
      <>
        <div>{t('coursesPage.computerNotAvailable')}</div>
        <div>{t('coursesPage.waitForTrainerToPrepareComputer')}</div>
      </>
    );
  }

  const messageToRender = (
    <>
      <MissingPreviewLinkIcon
        src={computer_connection_unavailable}
        alt="computer_connection_unavailable"
      />

      <InfoText>{textToRender}</InfoText>
    </>
  );

  return <ContentWrapper>{messageToRender}</ContentWrapper>;
};
